import PropTypes from "prop-types";
import { Menu } from "antd";
import { PoweroffOutlined } from "@ant-design/icons";
import i18n from "i18n";

const AccountMenu = ({ logOut }) => (
  <Menu
    className="user-setting-menu"
    items={[
      {
        key: "logout",
        icon: <PoweroffOutlined />,
        label: i18n.t("menuAccount.logOut"),
        onClick: () => logOut(),
      },
    ]}
  />
);

AccountMenu.propTypes = {
  logOut: PropTypes.func.isRequired,
};
export default AccountMenu;
